export default {
  API_BASE_URL: `https://obscure-brushlands-88158.herokuapp.com/api/`,
}
  